import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./reducers/authentication";
import browserConfigReducer from "./reducers/browserConfig";
import dashboardReducer from "./reducers/dashboard";
import partyReducer from "./reducers/party";
import orderReducer from "./reducers/purchaseOrder";
import grnReducer from "./reducers/grn"
import invoiceReducer from "./reducers/invoice"

const reducers = combineReducers({
  authentication: authReducer,
  browser: browserConfigReducer,
  dashboard: dashboardReducer,
  party: partyReducer,
  order: orderReducer,
  grn: grnReducer,
  invoice: invoiceReducer
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["authentication", "party", "dashboard", "oauth"],
};

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export default store;

export const resetAllStoreStates = () => {
  // console.log("Calling reset all redux store states");
  store.dispatch({ type: "RESET_ALL" });
};
